import {
  DebouncedTextInput,
  FormTab,
  Group,
  GroupItem,
  Toolbar,
  ValidationSummary,
  useSaveMutation,
} from "ra-friendsofbabba";
import React, { useMemo } from "react";
import {
  TabbedForm,
  required,
  useNotify,
  useQuery,
  useQueryWithStore,
  useRedirect,
  useRefresh,
  useTranslate,
} from "react-admin";

import AddButton from "./buttons/AddButton";
import BackButton from "./buttons/BackButton";
import CronoField from "../component/field/CronoField";
import HelpBlock from "../component/HelpBlock";
import { MonthMapInput } from "../component/input";
import WpActivitiesField from "./fields/WpActivitiesField";
import WpDeliverablesField from "./fields/WpDeliverablesField";
import { get } from "lodash";

const Form = (props) => {
  const redirect = useRedirect();
  const refresh = useRefresh();
  const notify = useNotify();
  const translate = useTranslate();
  const { data: config } = useQueryWithStore({
    type: "get",
    resource: "executive-project-wps/config",
    payload: {
      ...props?.record,
    },
  });
  const { data: wps } = useQuery({
    type: "get",
    resource: "executive-project-wps",
    payload: {
      executive_project_id: props?.record?.executive_project_id || 0,
    },
  });

  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      notify(`resources.executive-project-wps.messages.save_success`);
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });
  const label = useMemo(() => {
    const index = get(props.record, "index", 1);

    return translate("resources.executive-project-wps.tabs.general", {
      index: index,
      smart_count: index,
    });
  }, [props.record, translate]);

  return (
    <TabbedForm
      {...props}
      save={save}
      warnWhenUnsavedChanges
      toolbar={
        <Toolbar
          backTab={1}
          backReference="executive-projects"
          backReferenceTarget="executive_project_id"
          useBackButton={false}
        >
          <AddButton config={config} />
          <BackButton />
        </Toolbar>
      }
    >
      <FormTab label={label}>
        <ValidationSummary
          message={{
            explain: translate(
              "resources.executive-project-wps.validation_summary.explain"
            ),
          }}
        />
        <HelpBlock
          elevation={1}
          resource="executive-project-wps"
          context="list"
        />
        <Group fullWidth>
          <GroupItem lg={8} md={10} sm={12}>
            <DebouncedTextInput
              maxLength={100}
              source="title"
              validate={required()}
            />
          </GroupItem>
        </Group>
        <Group fullWidth>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <MonthMapInput source="start_month" config={config} />
          </GroupItem>
          <GroupItem lg={4} md={5} sm={6} xs={12}>
            <MonthMapInput
              source="duration"
              dep="start_month"
              config={config}
            />
          </GroupItem>
        </Group>
        <DebouncedTextInput
          maxLength={4000}
          source="expected_results"
          validate={required()}
          fullWidth
          multiline
        />
        <WpActivitiesField source="executive_project_wp_activities" fullWidth />
        <WpDeliverablesField
          source="executive_project_wp_deliverables"
          fullWidth
        />
        <CronoField useValues wps={wps?.data} showSubTitle={false} />
      </FormTab>
    </TabbedForm>
  );
};
export default Form;
